<template>
  <div>
    <v-alert max-width="800" class="mt-6 mx-auto" type="info" text>{{ message }}</v-alert>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "Ressource non-trouvée"
    }
  }
}
</script>

<style>

</style>